// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2zsnm","title":"AfterFrontImage_title__9sYgP"};